import { inject, Injectable } from "@angular/core";
import { PermissionsService } from "../permissionsService/permissions.service";
import { AccountService } from "../account/account.service";
import { AccountCategory } from "src/app/models/api/accountManagement.model";
import { PermissionEnum } from "src/app/models/auth0/permission.enum";

@Injectable({
    providedIn: "root",
})
export class AccessService {
    private _permissionsService = inject(PermissionsService);
    private _accountService = inject(AccountService);

    public renderExportCSVButton(accountCategory: AccountCategory | null): boolean {
        return this._permissionsService.hasPermissions(PermissionEnum.viewer) && this._accountService.accountHasFullAccess(accountCategory);
    }

    public renderAPITabAndDocsButton(accountCategory: AccountCategory | null): boolean {
        return this._accountService.accountHasFullAccess(accountCategory);
    }
}
